<template>
    <!-- O SDK do Octadesk injeta o chat automaticamente na página -->
    <div></div>
</template>

<script>
export default {
    data() {
        return {
            octadeskReady: false,
            scriptLoaded: false,
            messageListener: null,
        }
    },
    computed: {
        isOpen() {
            return this.$store.getters['support/showDialog']
        },
        hasSupport() {
            return this.$store.getters['reseller/hasSupport']
        },
        user() {
            return this.$store.getters['auth/user']
        },
    },
    watch: {
        isOpen(newValue) {
            if (newValue && this.hasSupport) {
                this.openChat()
            } else {
                this.closeChat()
            }
        },
        // Quando o usuário mudar (login/logout), reinicializa o Octadesk
        user: {
            handler(newUser) {
                if (!newUser || !newUser.id) {
                    this.closeChat()
                    return
                }
                if (!this.hasSupport) return

                if (this.octadeskReady && window.octadesk && window.octadesk.chat) {
                    // SDK já carregado: apenas atualiza o login sem recarregar o script
                    this.login(window.octadesk.chat)
                } else if (!this.scriptLoaded) {
                    this.initOctadesk()
                }
            },
            deep: true,
        },
    },
    methods: {
        initOctadesk() {
            if (this.scriptLoaded) return

            // Primeiro, configura as opções ANTES de carregar o script
            window.octadesk = window.octadesk || {}

            const chatOptions = {
                subDomain: process.env.VUE_APP_OCTADESK_DOMAIN,
                showButton: 'false', // Esconde o botão padrão - usamos nosso próprio
                openOnMessage: 'false',
                showFooterPoweredBy: 'false',
            }

            // Só adiciona login se tiver dados do usuário
            if (this.user && this.user.name && this.user.email) {
                chatOptions.login = this.user.support_login
            }

            window.octadesk.chatOptions = chatOptions

            // Verifica se o script já foi inserido no DOM em uma sessão anterior
            const alreadyInDOM = document.querySelector(
                'script[src="https://cdn.octadesk.com/embed.js"]',
            )

            if (alreadyInDOM) {
                // Script já está no DOM; se o chat já estiver pronto, apenas conecta
                this.scriptLoaded = true
                if (window.octadesk && window.octadesk.chat) {
                    this.octadeskReady = true
                    this.listenOctadeskMessages()
                    this.$store.commit('support/switchLoadedState')
                } else {
                    this.waitForOctadesk()
                }
            } else {
                this.loadOctadeskScript()
            }
        },
        loadOctadeskScript() {
            const script = document.createElement('script')
            script.async = true
            script.src = 'https://cdn.octadesk.com/embed.js'
            script.onload = () => {
                this.scriptLoaded = true
                this.waitForOctadesk()
            }
            document.body.appendChild(script)
        },
        waitForOctadesk() {
            const checkInterval = setInterval(() => {
                if (window.octadesk && window.octadesk.chat) {
                    this.octadeskReady = true
                    this.listenOctadeskMessages()
                    this.$store.commit('support/switchLoadedState')
                    clearInterval(checkInterval)
                }
            }, 500)

            // Timeout de 10 segundos para não ficar verificando eternamente
            setTimeout(() => {
                clearInterval(checkInterval)
            }, 10000)
        },
        openChat() {
            const chat = window.octadesk && window.octadesk.chat
            if (!chat) {
                console.warn('Octadesk chat not ready yet')
                return
            }

            chat.showApp()

            this.login(chat)
        },
        login(chat) {
            chat.login(this.user.support_login)
        },
        closeChat() {
            const chat = window.octadesk && window.octadesk.chat
            if (!chat) return

            chat.hideApp()

            if (this.isOpen) {
                this.$store.commit('support/switchDialogState')
            }
        },
        listenOctadeskMessages() {
            // Remove listener anterior para não acumular em re-logins
            if (this.messageListener) {
                window.removeEventListener('message', this.messageListener)
            }

            this.messageListener = event => {
                if (event.data && event.data.name === 'changeIFrameClasses') {
                    const classes =
                        event.data.octachat && event.data.octachat.classes

                    if (classes && Array.isArray(classes)) {
                        const isChatOpen = classes.includes('octachatAppOpen')
                        const isChatClosed = classes.includes(
                            'octachatAppClose',
                        )

                        if (isChatClosed && this.isOpen) {
                            this.$store.commit('support/switchDialogState')
                        } else if (isChatOpen && !this.isOpen) {
                            this.$store.commit('support/switchDialogState')
                        }
                    }
                }
            }

            window.addEventListener('message', this.messageListener)
        },
    },
    mounted() {
        if (this.hasSupport && this.user && this.user.id) {
            this.initOctadesk()
        }
    },
    beforeDestroy() {
        if (this.messageListener) {
            window.removeEventListener('message', this.messageListener)
        }
    },
}
</script>
